export const environment = import.meta.env.MODE;

export const projectId = 'sada-atom';
export const clientSideLoggingAPIKey =
  'AIzaSyDjMnEry26rvGYBfOV5v0L1T2pSjJ7zY3k';

export const LOCAL = 'localhost';
export const DEV = 'dev';
export const QA = 'qa';
export const UAT = 'uat';
export const PRODUCTION = 'prod';

// TODO: [AM-1797] Unify the `env` and `environment` variables
let env;
const domain = window.location.hostname.toLowerCase();
// VITE_DEMO_MODE (set in source/.env.production) forces LOCAL behavior — MSW
// mocking, admin role, fake JWT — on the deployed Cloud Run prototype. Its
// hostname (…atomai-sandbox.com / …run.app) would otherwise resolve to
// PRODUCTION below and skip the entire mock bootstrap, breaking the demo.
if (
  import.meta.env.VITE_DEMO_MODE === 'true' ||
  domain.includes('localhost') ||
  domain.includes('local-atom')
) {
  env = LOCAL;
} else if (domain.includes('dev')) {
  env = DEV;
} else if (domain.includes('qa')) {
  env = QA;
} else if (domain.includes('uat')) {
  env = UAT;
} else {
  env = PRODUCTION;
}

const configuration = {
  constants: {
    LOCAL,
    DEV,
    QA,
    UAT,
    PRODUCTION,
  },
  env,
  environment,
  projectId,
  clientSideLoggingAPIKey,
};

export default configuration;
